<template>
  <v-container  v-if="resume.references.length > 0" class="py-2">
    <BaseDivider :title="this.$t('references')" />
    <div class="mb-1" v-for="(reference, i) in resume.references" :key="i">
      <template>
        <h4>{{ reference.name }} | {{ reference.jobTitle }}</h4>
        <p>
          {{ reference.description }} <br />
          {{ reference.contactInfo }}
        </p>
      </template>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "pinia";
import { useCreateResumeStore } from "@/modules/create_resume/store/CreateResumeStore";
import BaseDivider from "./BaseDivider.vue";
export default {
    computed: {
        ...mapState(useCreateResumeStore, ["resume"]),
    },
    components: { BaseDivider }
};
</script>

<style scoped></style>
